<template>
  <div class="active-list">
    <filter-panel :data="groups"
                  @search="filterChange">
      <div slot="title">数据截止：{{ endDate }}</div>
    </filter-panel>
    <data-list
      :table-style="{ name: 'mixture' }"
      :columns="columns"
      :data="data"
      :page="page"
      :loading="loading"
      :page-size="page.pageSize"
      @page-size-changed="pageSizeChanged"
      @page-changed="pageChanged"
      @sort-change="sortChange"
    ></data-list>
    <form-dialog
      :dialogVisible="dialogVisible"
      dialogWidth="850px"
      :dialogTitle="dialogTitle"
      @handleClose="handleClose"
    >
      <data-list
        :columns="warnColumns"
        :loading="warnLoading"
        :data="warnData"
      ></data-list>
      <p class="warning-log-remark">
        只显示最近5条日志，
        <el-button type="text" @click="getMoreLog"> 更多日志</el-button>
        请前往账户详情查看
      </p>
    </form-dialog>
  </div>
</template>

<script>
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel';
import adsApi from '@/backend/services/googleAds/googleAds.js';
import customer from '@/mixins/customer';
import { getDateList, encode } from '@/common/util.js';
import vm from '@/common/confirm.js';
import formDialog from '@/components/webManage/formDialog.vue';
import userSearch from "@/components/tools/userSearch";
import { mapActions, mapGetters } from 'vuex';

const _typeof = (item) => typeof item == 'undefined'
const dataList = listPageCreate({
  searchConfig: {
    api: api.googleAds.warnList,
    method: 'POST',
    config: {
      timeout: 60000
    }
  },
  getQuery(obj, that) {
    if (_typeof(obj.solveFlag)) obj.solveFlag = '0';
    if (_typeof(obj.priority)) obj.priority = '1';
    if (_typeof(obj.serviceStaffId)) obj.serviceStaffId = that.userId;
    const { listRuleItemId } = obj
    obj.listRuleItemId = listRuleItemId ? [listRuleItemId] : []
    that.listRuleItemId = obj.listRuleItemId
    return _.assign(obj, {
      customerId: that.CUSTOMER || that.getQueryCustomerId,
      serviceId: that.getQueryServiceId,
      beginTime: that.endDate
    });
  }
});
export default {
  name: 'warningList',
  mixins: [dataList, customer],
  components: {
    filterPanel,
    formDialog
  },
  data() {
    const self = this;
    const dateList = getDateList(2);
    const endDate = dateList[1].value;
    return {
      ruleTypes: [],
      ruleItemId: null,
      customerId: null,
      serviceId: null,
      endDate: endDate,
      groups: {
        multiples: [
          {
            defaultText: '解决状态',
            placeholder: '解决状态',
            label: '解决状态',
            prop: 'solveFlag',
            value: '0',
            emptyValue: null,
            options: [
              {
                label: '待解决',
                value: '0'
              },
              {
                label: '已解决',
                value: '1'
              }
            ]
          },
          {
            defaultText: '优先级',
            placeholder: '优先级',
            label: '优先级',
            prop: 'priority',
            value: '1',
            emptyValue: null,
            options: [
              {
                label: '一级',
                value: '1'
              },
              {
                label: '二级',
                value: '2'
              },
              {
                label: '三级',
                value: '3'
              }
            ]
          }
        ],
        others: [
          {
            tagName: 'sky-cascader',
            placeholder: '全部类型',
            label: '全部类型',
            prop: 'listRuleItemId',
            value: null,
            emptyValue: null,
            props: {
              label: 'name',
              value: 'id',
              children: 'ruleItemVOList'
            },
            checkStrictly: false,
            options: [],

          },
          {
            tagName: userSearch,
            placeholder: "服务人员",
            label: "服务人员",
            prop: "serviceStaffId",
            value: '',
            emptyValue: null
          },
        ]
      },
      dialogVisible: false,
      warnLoading: false,
      dialogTitle: '',
      columns: [
        {
          label: '解决状态',
          bind: 'solveFlag',
          type: 'mapping',
          width: '120px',
          mapType: 'iconfont',
          align: 'left',
          size: { fontSize: '23px' },
          parentEvent: row => {
            let status = [
              { label: 'remind1', value: 0 },
              { label: 'fasongchenggong', value: 1 }
            ];
            return status.find(item => row == item.value).label;
          },
          colors: row => {
            let status = [
              { label: { color: '#FCC262' }, value: 0 },
              { label: { color: '#78CE4D' }, value: 1 }
            ];
            return status.find(item => row.solveFlag == item.value).label;
          },
          message: row => {
            let status = [
              { label: '未解决', value: 0 },
              { label: '已解决', value: 1 }
            ];
            return status.find(item => row.solveFlag == item.value).label;
          }
        },

        {
          type: 'custInfo',
          label: '客户',
          text: [
            {
              bind: 'customerName',
              colType: 'popoverContent'
            },
            {
              label: '服务单号',
              bind: 'serviceCode',
              showItem: true
            },
            {
              label: 'CID',
              bind: 'cid',
              hidden: true
            },
            {
              label: '推广网站',
              bind: 'domain',
              clickFn (text) {
                if (text) {
                  if (text.includes("：")) {
                    const domain = text.split("：").pop();
                    if (domain != '-') window.open(`//${domain}`);
                  }
                }
              }
            }
          ]
        },
        {
          type: 'custInfo',
          label: '预警名称',
          text: [
            {
              bind: 'ruleItemName',
              colType: 'popoverContent'
            },
            {
              label: '预警类型',
              bind: 'ruleName',
              showItem: true
            },
            {
              label: '预警规则',
              bind: 'ruleItemVal',
              hidden: true
            }
          ]
        },
        {
          label: '优先级',
          bind: 'priorityStr',
          width: '120px'
        },
        {
          label: '当前值',
          type: 'custInfo',
          text: [
            {
              bind: 'remindVal',
              colType: 'transTextFormat',
              custValue(row, bind = 'remindVal') {
                if (row && row[bind] && row[bind].indexOf('</br>')) {
                  return row[bind].split('</br>').join('');
                }
              }
            }
          ]
        },
        {
          type: 'btnClick',
          style: 'text',
          label: '操作',
          align: 'center',
          width: '180px',
          bind: row => {
            let tempList = [
              {
                text: '预警日志',
                trigger(row) {
                  self.dialogVisible = true;
                  self.dialogTitle = row.ruleItemName;
                  const ids = [
                    'customerId',
                    'serviceId',
                    'ruleItemId',
                    'customerName',
                    'cid',
                    'serviceCode'
                  ];
                  ids.map(key => (self[key] = row[key]));
                  self.getWarningLog(row);
                }
              },
              {
                text: '标记已解决',
                trigger(row) {
                  self.isSolveFlag(row);
                }
              }
            ];
            if (row.solveFlag == 1) {
              let newTempList = _.cloneDeep(tempList);
              return newTempList.filter(item => item.text == '预警日志');
            }
            return tempList;
          }
        }
      ],
      warnColumns: [
        {
          label: '日期',
          bind: 'createTime'
        },
        {
          label: '预警项',
          bind: 'ruleItemName'
        },
        {
          label: '预警类型',
          bind: 'ruleName',
          width: '130px'
        },
        {
          label: '日志记录原因',
          bind: 'operationTypeStr'
        },
        {
          label: '详情',
          type: 'custInfo',
          text: [
            {
              bind: 'details',
              colType: 'transTextFormat',
              custValue (row, bind = 'details') {
                if (
                  row &&
                  row[bind] &&
                  row[bind] &&
                  row[bind].indexOf('</br>')
                ) {
                  return row[bind].split('</br>').join('');
                }
              }
            }
          ]
        }
      ],
      warnData: [],
      customerName: '',
      cid: '',
      serviceCode: "",
      listRuleItemId: [],
    };
  },
  methods: {
    ...mapActions(['getWarningType']),
    handleClose() {
      this.dialogVisible = false;
    },
    getMoreLog() {
      this.$router.push({
        name: 'warningLog',
        query: {
          serviceId: this.serviceId,
          customerId: this.customerId,
          ruleItemId: this.ruleItemId,
          customerName: encode(this.customerName),
          cid: this.cid,
          serviceCode: encode(this.serviceCode)
        }
      });
      this.dialogVisible = false
    },
    async ruleTreeList() {
      try {
        let res = await this.getWarningType();
        this.ruleTypes = res;
        this.setGroups();
      } catch (e) {
        console.error(e);
      }
    },
    async isSolveFlag(row) {
      try {
        let res = await adsApi.signSolve({ id: row.id });
        if (res.status >= 200 && res.status < 400) {
          this.query();
          vm._success('操作成功');
        }
      } catch (e) {
        console.error(e);
        vm._info('操作失败');
      }
    },
    async getWarningLog(row) {
      try {
        this.warnLoading = true;
        this.warnData = [];
        const { customerId, serviceId, ruleItemId } = row;
        let res = await adsApi.warningLog({
          customerId,
          serviceId,
          listRuleItemId: [ruleItemId],
          displayStart: 1,
          displayLength: 5
        });
        if (res.status >= 200 && res.status < 400) {
          this.warnData = res.data.data;
          this.warnLoading = false;
        }
      } catch (e) {
        this.warnLoading = false;
        this.warnLoading = false;
        console.error(e);
      }
    },
    setGroups() {
      const self = this;
      this.groups.others[0].options = self.ruleTypes;
      this.groups.multiples[1].value = this.$route.query.type || '1';
    }
  },
  computed: {
    ...mapGetters(['userId']),
    getQueryServiceId () {
      return this.$route.query.serviceId;
    },
    getQueryCustomerId() {
      return this.$route.query.customerId;
    }
  },
  created () {
    this.groups.others.forEach(item => {
      if (item.prop == 'serviceStaffId') {
        this.$set(item, 'value', this.userId)
      }
    })
  },
  mounted () {
    this.ruleTreeList();
    this.query()
  }
};
</script>

<style lang="scss" scoped>
.warning-log-remark:not(.el-button) {
  text-align: center;
  color: #9c9a9a;
  margin: 10px 0 0;
}
</style>
